import type { AuthenticationAccessRight } from "src/authentication/objects/AuthenticationToken";

export default class IntegrationAccessRight {
  public static VIEW_INTEGRATIONS: AuthenticationAccessRight = ({
    menuDisplayLevel,
  }) => menuDisplayLevel === 0;
  public static CONFIGURE_SHOPIFY: AuthenticationAccessRight = ({
    menuDisplayLevel,
  }) => menuDisplayLevel === 0;
  public static CONFIGURE_WISEPOPS: AuthenticationAccessRight = ({
    menuDisplayLevel,
  }) => menuDisplayLevel === 0;
}
